export default __webpack_public_path__ + "static/side-nav-do-5-dea29ff7e3973df836e9789421c5a0e06b55b9721a3c081ac6da0a6609f84c3c.png";